export var LIMIT_TYPE = {
  QUOTA_LIMIT: 0,
  STOCK_LIMIT: 1
};

export var UNSELECTED_SKU_VALUE_ID = '';

export default {
  LIMIT_TYPE: LIMIT_TYPE,
  UNSELECTED_SKU_VALUE_ID: UNSELECTED_SKU_VALUE_ID
};


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/sku/constants.js
// module id = 40
// module chunks = 80